import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=36bb62df&scoped=true"
import script from "./BlackList.vue?vue&type=script&lang=js"
export * from "./BlackList.vue?vue&type=script&lang=js"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=36bb62df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb62df",
  null
  
)

export default component.exports